import React from 'react';
import { Link } from 'react-router-dom';
import { Package, ListTodo, ShoppingCart, Download, X, Info, FileUp, Settings } from 'lucide-react';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={onClose} />
      <div className="fixed inset-y-0 right-0 max-w-xs w-full bg-white shadow-xl flex flex-col">
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">Menu</h2>
          <button
            onClick={onClose}
            className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        <nav className="flex-1 pt-4">
          <Link
            to="/"
            className="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-50"
            onClick={onClose}
          >
            <Package className="w-5 h-5 mr-3" />
            Live
          </Link>
          <Link
            to="/orders"
            className="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-50"
            onClick={onClose}
          >
            <ListTodo className="w-5 h-5 mr-3" />
            Commande
          </Link>
          <Link
            to="/woo"
            className="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-50"
            onClick={onClose}
          >
            <ShoppingCart className="w-5 h-5 mr-3" />
            Woo
          </Link>
          <Link
            to="/sauvegarde"
            className="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-50"
            onClick={onClose}
          >
            <Download className="w-5 h-5 mr-3" />
            Sauvegarde
          </Link>
          <Link
            to="/database"
            className="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-50"
            onClick={onClose}
          >
            <Info className="w-5 h-5 mr-3" />
            Infos
          </Link>
          <Link
            to="/import-csv"
            className="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-50"
            onClick={onClose}
          >
            <FileUp className="w-5 h-5 mr-3" />
            Import
          </Link>
          <Link
            to="/connection"
            className="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-50"
            onClick={onClose}
          >
            <Settings className="w-5 h-5 mr-3" />
            Connection
          </Link>
        </nav>
      </div>
    </div>
  );
}